import { Injectable } from '@angular/core';
import { BaseServiceClient, MfDocumentDto } from '@shared/data';
import { Observable } from 'rxjs';
import { ReimbursementClaimDto } from '../interface/dto/features/reimbursement/reimbursement-claim-dto';
import { ReimbursementRequestBodyDto } from '../interface/dto/features/reimbursement/reimbursement-claim-request-dto';

@Injectable({
    providedIn: 'root',
})
export class ReimbursementServiceClientService extends BaseServiceClient {
    private readonly BaseUrl = `${this.ApiBaseUrl}${this.appConstants.httpClient.mcaBase}`;

    public sendReimbursementClaim(data: ReimbursementRequestBodyDto): Observable<string> {
        return this.post(`${this.BaseUrl}/reimbursements/`, data);
    }

    public getCustomerReimbursementClaims(customerId: string): Observable<ReimbursementClaimDto[]> {
        return this.get(`${this.BaseUrl}/customers/${customerId}/reimbursements`);
    }

    public cancelReimbursementClaim(customerId: string, claimId: string): Observable<unknown> {
        return this.put(`${this.BaseUrl}/customers/${customerId}/reimbursements/${claimId}/cancel`);
    }

    public getMedifitDocument(reimbursementClaimId: string, customerId: string, maskedDocumentId: string): Observable<MfDocumentDto> {
        const url = `${this.BaseUrl}/customers/${customerId}/reimbursements/${reimbursementClaimId}/documents/${maskedDocumentId}`;
        return this.fetchDocument(url);
    }

    public getExternalDocument(reimbursementClaimId: string, customerId: string, documentId: string): Observable<MfDocumentDto> {
        const url = `${this.BaseUrl}/customers/${customerId}/reimbursements/${reimbursementClaimId}/external/documents/${documentId}`;
        return this.fetchDocument(url);
    }
}
